import { ProgressCircle } from '@infinex/ui/components';

export function Loading() {
  // here we applied two changes to ProgressCircle:
  // 1. we hide the placeholder stroke
  // 2. we set the diameter to 54px
  return (
    <div className="bg-surface fixed inset-0">
      <div className="flex h-full w-full items-center justify-center">
        <div className="flex flex-col items-center justify-center gap-y-8 [&_.stroke-placeholder]:hidden">
          <ProgressCircle
            aria-label="Loading…"
            isIndeterminate
            size="xlarge"
            prominence="high"
            style={
              {
                '--diameter': '54px',
              } as React.CSSProperties
            }
          />
        </div>
      </div>
    </div>
  );
}
